import { Chip } from "@mui/material";
export const grid_columns = [
  { field: "id", headerName: "ID", width: 90 },
  {
    field: "title",
    headerName: "Title",
    width: 350,
  },
  {
    field: "description",
    headerName: "Description",
    width: 370,
  },
  {
    field: "status",
    headerName: "Status",
    type: "boolean",
    align: "center",
    headerAlign: "center",
    width: 180,
    disableColumnMenu: true,
    renderCell: (params) =>
      params.row.is_deleted ? (
        <Chip
          label="Not Published"
          style={{ backgroundColor: "#FAA0A0", color: "#FF0000" }}
        />
      ) : (
        <Chip
          label="Published"
          style={{ backgroundColor: "#C1E1C1", color: "#4A8800" }}
        />
      ),
  },
  {
    field: "updated_at",
    headerName: "Date",
    width: 120,
  },
];
